<template>
  <v-container class="limited">
    <v-layout column>
      <dados-beneficiario></dados-beneficiario>
      <v-container
        grid-list-md
        class="pa-0"
        v-bind="{ [`grid-list-lg`]: true }"
      >
        <v-layout row wrap>
          <v-flex xs12 sm12 md10 lg9>
            <v-card class="pa-4">
              <v-layout column>
                <v-layout row wrap>
                  <v-flex xs12 md6 id="cartaoFrente">
                    <cartao-frente
                      :beneficiario-cartao="beneficiarioCartao"
                      @cartao-frente="alteraCartaoFrenteCarregado"
                    ></cartao-frente>
                  </v-flex>
                  <v-flex xs12 md6>
                    <cartao-verso
                      :beneficiario-cartao="beneficiarioCartao"
                      @cartao-verso="alteraCartaoVersoCarregado"
                      :informacoes-verso="informacoesVerso"
                    ></cartao-verso>
                  </v-flex>
                </v-layout>
                <v-layout align-center justify-end row>
                  <segunda-via
                    id="btnSegVia"
                    :dados-beneficiario="dadosBeneficiario"
                    :familia-pessoa="familiaPessoa"
                  ></segunda-via>
                </v-layout>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <loading-dialog :show="loading" message="Aguarde..."></loading-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DadosBeneficiario from "@/components/BeneficiaryData";
import LoadingDialog from "@/components/LoadingDialog";

import CartaoFrente from "./cartao-frente";
import CartaoVerso from "./cartao-verso";
import SegundaVia from "./segunda-via";

import { PARAMETROS, INFORMACOES_VERSO_CARTAO } from "@/constants";
import { getParametroCartaoVerso } from "@/services/beneficiario";

const { mapState } = createNamespacedHelpers("beneficiario");

export default {
  name: "Carteirinha",
  components: {
    CartaoFrente,
    CartaoVerso,
    DadosBeneficiario,
    LoadingDialog,
    SegundaVia
  },
  computed: {
    ...mapState(["dadosBeneficiario", "familiaPessoa"]),
    beneficiarioCartao() {
      return this.dadosBeneficiario.id;
    }
  },
  created() {
    this.buscaParametro();
  },
  watch: {
    cartaoFrenteCarregado: {
      handler() {
        this.loading = this.cartaoFrenteCarregado || this.cartaoVersoCarregado;
      }
    },
    cartaoVersoCarregado: {
      handler() {
        this.loading = this.cartaoFrenteCarregado || this.cartaoVersoCarregado;
      }
    }
  },
  data() {
    return {
      cartaoFrenteCarregado: false,
      cartaoVersoCarregado: false,
      loading: false,
      informacoesVerso: {
        informacoes_ans: true,
        telefone_ouvidoria: true,
        sac_telefone: true,
        este_cartao_numerado_nominativo_intransfervel: true,
        valido_somente_com_apresentacao_documento_identidade: true
      }
    };
  },
  methods: {
    alteraCartaoFrenteCarregado(value) {
      this.cartaoFrenteCarregado = value;
    },
    alteraCartaoVersoCarregado(value) {
      this.cartaoVersoCarregado = value;
    },
    async buscaParametro() {
      var parametroValores = await getParametroCartaoVerso(
        PARAMETROS.MENSAGEM_ANS_CARTAO_VERSO
      );

      parametroValores.forEach(e => {
        if (INFORMACOES_VERSO_CARTAO[e.valor]) {
          this.informacoesVerso[e.valor] = false;
        }
      });
    }
  }
};
</script>
<style>
#cartaoFrente {
  max-width: 55%;
  z-index: 1;
}
#btnSegVia {
  margin-top: 60px;
}
</style>
